/* CRO backlog #17 monitor (2026-07-11): a single ux-researcher session on a
 * Khurmani PDP showed raw CSS ("nav-menu-tab{background:") rendering as
 * visible page text — unreproducible on static review (the cited class only
 * exists in a pre-redesign backup, not current code) and the weakest-evidence
 * row in the whole CRO audit (single observation, no repeat pattern). Same
 * bug class as the /cart monitor added for backlog #9. Passive detection
 * only — never alters the page — so a recurrence on any PDP surfaces without
 * waiting for another rare session recording.
 */
(function () {
  'use strict';

  var RAW_CODE_PATTERN = /if\s*\(typeof\b|<\/script|function\s*\([^)]*\)\s*\{|=>\s*\{|document\.(querySelector|getElementById|createElement)\(|\.[a-zA-Z-]+\{(background|color|display|width|height)\s*:/;

  function scanForRawCodeLeak(root) {
    try {
      var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          var tag = node.parentElement && node.parentElement.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        if (text && RAW_CODE_PATTERN.test(text)) {
          var snippet = text.trim().slice(0, 120);
          console.error('[sindhi-pdp-monitor] Raw code text detected in visible DOM:', snippet);
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'raw_code_leak_detected', {
              event_category: 'pdp_integrity',
              page_path: window.location.pathname,
              snippet: snippet,
            });
          }
          return;
        }
      }
    } catch (e) {
      /* the monitor must never itself break the page */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanForRawCodeLeak(); });
  } else {
    scanForRawCodeLeak();
  }
})();
